const API_CACHE_MARKER = "-api-";

export async function clearApiCache(): Promise<void> {
  if (typeof caches === "undefined") {
    return;
  }
  try {
    const names = await caches.keys();
    await Promise.all(
      names
        .filter((name) => name.includes(API_CACHE_MARKER))
        .map((name) => caches.delete(name))
    );
  } catch (error) {
    console.warn("clearApiCache: failed to clear API cache", error);
  }
}
